// extracted by mini-css-extract-plugin
export default {"container":"Maa-z","oos":"Naa-z","oosUx":"Oaa-z","selected":"Paa-z","labelOos":"Qaa-z"};